// react imports
import React, { Component } from "react"

// package imports
import { Col, Container, Row } from "react-bootstrap"
import { observer } from "mobx-react"
import { toJS } from "mobx"

// project imports
import SolutionStore from "./store/SolutionStore"
import { BottomsheetDropdown, TabComponent } from "components"
import SolutionScreenSingleLaCard from "./components/solution-screen-single-la-card/SolutionScreenSingleLaCard"
import SolutionScreenMulipleLaCard from "./components/solution-screen-multiple-la-card/SolutionScreenMulipleLaCard"
import UnderlyingCard from "./components/underlying-card/UnderlyingCard"
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

// import solutionDataStructure from './solution-data'
import savePragatiNAInboundData from "utils/savePragatiNAInboundData"
import AuthStore from "modules/login/store/AuthStore";
import ProductNames from "constants/ProductNames"
import './solution.css'
import QuotationPreviewStore from "modules/quotation-preview/QuotationPreviewStore"
import utils from "modules/quotation-preview/utils"
import language from "constants/Language"

const Solution = observer(
  class Solution extends Component {

    constructor(props) {
      super(props)
      console.log(this?.props?.location?.state?.solutionList, "SolutionScreenProps")
      this.state = {
        // dataList: data.data,
        protectionValues: [
          { title: "Zindagi Plus", percentValue: "40", ammount: "5,000" },
          { title: "Wealth Ultima", percentValue: "75", ammount: "36,000" },
          { title: "Simply Protect", percentValue: "70", ammount: "12,000" },
        ],
        showConsolidatedPremiumModal: false,
        numPages: 1,
        tabList: [],
        selectedTabIndex: "0",
        seletedTabData: {},
        seletedTabDataQuotation: [],
        seletedPdfLanguage: { id: "english", label: "English" }

      }
      this.setSelectedTabIndex = this.setSelectedTabIndex.bind(this)
    }

    openConsolidatedPremiumModal = (e) => {
      this.setState({ showConsolidatedPremiumModal: true })
    }

    closeConsolidatedPremiumModal = (e) => {
      this.setState({ showConsolidatedPremiumModal: false })
    }

    async componentDidMount() {
      window.scrollTo(0, 0)
      await savePragatiNAInboundData(location)
      this.setState({ seletedTabData: toJS(SolutionStore.user_list_data[0]), tabList: toJS(SolutionStore.user_list_data) })
      SolutionStore.setSeletedSolutionTabData(toJS(SolutionStore.user_list_data[0]))


      await savePragatiNAInboundData(location)
      this.successQuotationHandler();
      this.setState({ seletedTabDataQuotation: this.state.tabList[0] });
      let userListData = toJS(SolutionStore.user_list_data)
      AuthStore.setSolutionData(userListData[0])
    }


    componentDidUpdate(prevProps, prevState) {
      if (prevState.selectedTabIndex != this.state.selectedTabIndex) {
        toJS(SolutionStore.user_list_data).forEach((item, index) => {
          if (index.toString() === this.state.selectedTabIndex) {
            this.setState({ seletedTabData: item })
            SolutionStore.setSeletedSolutionTabData(item)
          }
        })

        this.state.tabList.forEach((item, index) => {
          if (index.toString() === this.state.selectedTabIndex) {
            this.setState({ seletedTabDataQuotation: item });
            SolutionStore.setSeletedSolutionTabData(item);
          }
        });
      }
    }

    laNameFunction(singleLA) {
      let { la_salutation, la_name, la_family_member_type } = singleLA

      if (la_name) return la_name

      return la_family_member_type
    }

    downloadSampleBi(familyProductDetailsId) {
      SolutionStore.downloadSampleBiPdf(familyProductDetailsId)
    }

    showDownloadSampleBiBtn() {
      let asbOption = false
      if (this.state.seletedTabData?.productList.length > 0) {
        let productData = this.state.seletedTabData?.productList.filter((item) => Number(item.productId) === Number(ProductNames.flexiSavingsPlan))
        if (productData.length > 0) {
          productData.forEach((data) => {
            if (data.inputString.find(item => item.Key === '@DISPLAY_PR_OPTION_4').Value === 'Yes' && !asbOption) {
              asbOption = true
            }
          })
        }
      }
      return asbOption
    }
    setSelectedTabIndex(tabIndex) {
      this.setState({ selectedTabIndex: tabIndex });
      let userListData = toJS(SolutionStore.user_list_data)
      AuthStore.setSolutionData(userListData[Number(tabIndex)])
      QuotationPreviewStore.setSelectedTabData(this.state.tabList[Number(tabIndex)])
    }



    onDocumentLoadSuccess = ({ numPages }) => {
      this.setState({ numPages: numPages });
    };

    successQuotationHandler = async (selectLanguage) => {

      const solutionList = localStorage.getItem("solutionList");
      if (solutionList) {
        let documentData = await utils.fetchDocument(JSON.parse(solutionList), selectLanguage);
        SolutionStore.showPdfGeneratingMsg(false)

        if(documentData.length > 0 ){
           let getLanguage =  language.find((item)=> item.id === documentData[0].language )
           this.setState({ seletedPdfLanguage: getLanguage })
        }
        if (documentData) {
          documentData.forEach((item) => {
            item.tabTitle = item.proposer_name;
          });
          this.setState({ tabList: documentData, seletedTabDataQuotation: documentData ? documentData[0] : [] });
          QuotationPreviewStore.setSelectedTabData(documentData ? documentData[0] : [])
          SolutionStore.dmsDocumentData = documentData || [];

        }
      }
    };

    render() {
      // const { showConsolidatedPremiumModal } = this.state
      // const dataList = toJS(SolutionStore.user_list_data)
      // const needDataList = toJS(SolutionStore.needDataList)
      // const totalPremium = toJS(SolutionStore.totalPremium)
      // const totalTax = toJS(SolutionStore.totalTax)

      const coverageArray = this.state.seletedTabData?.coverage

      let details = toJS(SolutionStore.soluctionData)

      if (details <= 0 ||  coverageArray === undefined) return null

      if (details <= 0 ||  coverageArray === undefined) return null

      return (
        <Container className="solution-container">
          <Row>
            <Col xs="12" md="12" lg="12" className="mt-5 mx-auto">
              <p className="text-primary font-weight-bold font-size-16 font-size-lg-18 mb-3 pb-0 pl-4">
                Solution Coverage
              </p>
              {details.map((item) => {

                if (item.laList.length >= 2) {
                  return <SolutionScreenMulipleLaCard
                    CardName={item.needTitle}
                    detail={item}
                  />
                }
                return null

              })}

              <Row className="px-2 d-flex flex-column flex-lg-row  mt-2">
                {details.map((singleItem, index) => {
                  if (singleItem.laList.length < 2) {

                    return <SolutionScreenSingleLaCard
                      singleLaCard={true}
                      key={index}
                      CardName={singleItem.needTitle}
                      detail={singleItem}
                    />
                  }
                  return null
                })}
              </Row>
            </Col>


            <Container className='quotation-preview-page mt-5 mt-md-2 mb-5 pb-5 pb-md-0'>
              <Row>
                <Col md={6}>
                  <p className='quotation-preview-title font-weight-medium font-size-18 mb-0'>Solution Quote Preview</p>
                  <p className='quotation-preview-sub-title font-weight-light font-size-12'>Preview the quotation document before sending to the client.</p>
                </Col>
                <Col md={6}>
                  <div className="d-flex justify-content-end">
                    <div className="align-items-center justify-content-between language-dropdown-width">
                      <span className="text-nowrap font-size-14 font-size-md-12 font-weight-400 description-text-color mb-0 mt-2 mt-md-0 need-label-width mr-2 text-black">
                        Select Language
                      </span>
                      <div className="drop-down-style w-100">
                        <BottomsheetDropdown
                          disabled={false}
                          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light w-100 bg-white'
                          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                          menuItemStyle='d-flex justify-content-between align-items-center'
                          selectedLabelKey="label"
                          menuList={language}
                          onSelect={(value) => {
                            this.setState({ seletedPdfLanguage: value })
                            this.successQuotationHandler(value?.id)
                          }}
                          value={this.state.seletedPdfLanguage}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Col xs='12'>
                <TabComponent tabList={this.state.tabList} setSelectedTabIndex={this.setSelectedTabIndex} />
              </Col>

              {this.state.seletedTabDataQuotation && (
                <center>
                  <div className='pdf-container'>
                    <Document file={this.state.seletedTabDataQuotation?.url} onLoadSuccess={this.onDocumentLoadSuccess}>
                      {Array.from(new Array(this.state.numPages), (el, index) => (
                        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                      ))}
                    </Document>
                  </div>
                </center>
              )}

            </Container>
            <Col
              xs="12"
              lg="12"
              className="protection-coverage-card-col mb-4 mb-lg-5 d-flex flex-column"
            >
              <p className="text-primary font-weight-bold font-size-16 font-size-lg-18 mb-3 pb-0 pl-4">
                Underlying Products
              </p>
              <div className="under-lying-card-container bg-white d-inline-block w-100 px-3 px-lg-3 pt-3 pb-1 pt-lg-4 mb-lg-0">
                {this.state.seletedTabData?.productList?.map((value, index) => (
                  <UnderlyingCard key={index} productData={value} />
                ))}
              </div>
            </Col>
          </Row>

        </Container>
      )
    }
  }
)

export default Solution
